import SvgIcon from '../SvgIcon';
import * as React from 'react';

interface Props {
  readonly isOn: boolean;
}

export const Checkbox = ({ isOn }: Props) => {
  const iconName = isOn ? 'ic-check-green' : 'ic-check-gray';
  return <SvgIcon iconWidth={17} iconHeight={17} iconName={iconName} />;
};



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.tsx